import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MobileService } from '@shared/services/mobile.service';
import { ScopeService } from '@shared/services/scope.service';
import { ActionEnabledRule, ActionTrigger, TableAction, TableActions } from './action';

/**
 * Displays and triggers actions with a name and icon for interacting with selected items.
 */
@Component({
  selector: 'rav-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.scss']
})
export class ActionsComponent {
  @Input() totalItems: number;
  @Input() actions: TableAction[];
  @Input() selectedItems: any[];
  @Input() isTable = false;
  @Output() actionTriggered = new EventEmitter<ActionTrigger<any>>();
  TableActions = TableActions;

  constructor(public scope: ScopeService, private mobile: MobileService) {}

  /**
   * Returns the name of the current icon to display depending on the actions disabled state.
   */
  currentIcon(action: TableAction): string {
    return TableActions.isEnabled(action, this.selectedItems) ? action.iconEnabled : action.iconDisabled;
  }

  /**
   * Determines whether to show the action.
   */
  showAction(action: TableAction): boolean {
    if (!this.isTable) return true;
    if (this.mobile.isMobileDisplay() && action.name !== 'Create New' && action.name !== 'Add New') return false;
    return true;
  }

  /**
   * Returns the correct text for the action button.
   */
  actionName(action: TableAction): string {
    return this.mobile.isMobileDisplay() && action.shortName ? action.shortName : action.name;
  }

  /**
   * Shows a specific tooltip according to some conditions of the action.
   *
   * @param action TableAction for which you want to display the tooltip
   * @returns Custom tooltip message
   */
  getCustomTooltip(action: TableAction): string {
    if (
      action === TableActions.downloadFileSystem &&
      !TableActions.evaluateRule(ActionEnabledRule.If2OrMoreSelected_E2EEShouldBeDisabled, this.selectedItems)
    ) {
      return 'Only one file can be downloaded at a time when E2E Encryption is enabled.';
    }
  }
}
